import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Input, Label, Spinner, Text } from '@fluentui/react-components';
import { useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
export function Login({ message }) {
    const { login } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [pending, setPending] = useState(false);
    const [error, setError] = useState(null);
    const submit = async (event) => {
        event.preventDefault();
        setPending(true);
        setError(null);
        try {
            await login(email, password);
        }
        catch (err) {
            setError(authMessage(err));
        }
        finally {
            setPending(false);
        }
    };
    return (_jsxs("form", { onSubmit: submit, style: { padding: 20, display: 'flex', flexDirection: 'column', gap: 12 }, children: [_jsx("div", { "aria-hidden": true, style: {
                    width: 56,
                    height: 56,
                    borderRadius: 14,
                    background: 'linear-gradient(135deg,#062b5f,#001c42)',
                    color: 'white',
                    display: 'grid',
                    placeItems: 'center',
                    fontWeight: 800,
                    fontSize: 24,
                    margin: '0 auto 4px',
                }, children: "B" }), _jsx(Text, { size: 500, weight: "semibold", style: { textAlign: 'center' }, children: "Bleinks E-Sign" }), _jsx(Text, { size: 200, style: { color: '#605e5c', textAlign: 'center' }, children: message ?? 'Sign in securely with your Bleinks account.' }), _jsx(Label, { htmlFor: "bleinks-email", children: "Email" }), _jsx(Input, { id: "bleinks-email", type: "email", value: email, onChange: (_, data) => setEmail(data.value), autoComplete: "email", required: true }), _jsx(Label, { htmlFor: "bleinks-password", children: "Password" }), _jsx(Input, { id: "bleinks-password", type: "password", value: password, onChange: (_, data) => setPassword(data.value), autoComplete: "current-password", required: true }), _jsx(Button, { appearance: "primary", type: "submit", disabled: pending || !email || !password, children: pending ? _jsx(Spinner, { size: "tiny", label: "Signing in\u2026" }) : 'Sign in to Bleinks' }), error && (_jsx(Text, { size: 200, style: { color: '#a4262c', textAlign: 'center' }, children: error })), _jsx(Text, { size: 100, style: { color: '#8a8886', textAlign: 'center', marginTop: 8 }, children: "Authentication is handled by Firebase. Your password is never stored by the add-in." })] }));
}
function authMessage(error) {
    const code = typeof error === 'object' && error && 'code' in error ? String(error.code) : '';
    if (code.includes('invalid-credential'))
        return 'The email or password is incorrect.';
    if (code.includes('too-many-requests'))
        return 'Too many attempts. Please wait and try again.';
    return error instanceof Error ? error.message : 'Sign-in failed.';
}
